import { useEffect, useState } from 'react';
import { useFormContext } from 'shared-widget-components/src/providers/FormContextProvider';
import { Carousel } from '../../../models/CarouselModel';

/**
 * Custom hook to reset the form and update the widgetstate with data from backend
 * @param data - data from backend
 * @returns {object} - object containing the languageCode
 */
export const useWidgetBody = (data: string, buttonColor?: string, buttonTextColor?: string, primaryColor?: string) => {
  //@ts-ignore
  const languageCode = window.currentLanguageCode;
  const { reset, errors } = useFormContext();

  const [isValidationError, setIsValidationError] = useState(false);

  const showErrorMessage = () => {
    setIsValidationError(true);
    console.log('showErrorMessage -> errors', errors);
    setTimeout(() => {
      setIsValidationError(false);
    }, 2000);
  };

  // update widgetstate with data from backend
  useEffect(() => {
    try {
      const parsedData: Carousel = JSON.parse(data);
      reset({
        backgroundColor: parsedData.backgroundColor ?? primaryColor,
        textColor: parsedData.textColor ?? buttonTextColor,
        buttonColor: parsedData.buttonColor ?? buttonColor,
        slides: parsedData.slides ?? [],
        autoPlay: parsedData.autoPlay ?? true,
        buttonTextColor: parsedData.buttonTextColor ?? buttonTextColor,
      });
    } catch (error) {
      throw new Error('Hiba az adatok betöltése közben!');
    }
  }, [data, buttonColor, buttonTextColor, primaryColor]);

  return { languageCode, isValidationError, showErrorMessage };
};
